export const iconFontAwesomeConstructionTarpDroplet = (
	<i className="fa-solid fa-tarp-droplet"></i>
);
